import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import confirm from "../../assets/confirm.png";
import apiKey from "../../config/apiKey";

const ConfirmPass = () => {
  const [formData, setFormData] = useState({
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState({});
  const { token } = useParams();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${apiKey}/api/edolutions/resetpassword/${token}`, {
        password: formData.password,
        password_confirmation: formData.password_confirmation,
      });
      toast.success("Password reset successfully!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: {
          backgroundColor: "#4FD1C5", // Customize background color
          color: "#fff", // Customize text color
        },
      });
      navigate("/login");
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        setErrors(error.response.data.errors);
      } else {
        toast.error("Failed to reset password. Please try again.", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(160deg, #FFF8F2 0%, #FFE9D6 45%, #FFD9BF 100%)" }}>
      <div className="w-full max-w-md mx-4">
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Fredoka',sans-serif" }}>
              <span className="text-[#EE5F2B]">Cabil</span>
            </h1>
            <h2 className="text-xl font-bold text-gray-800 mt-3">Set New Password</h2>
            <p className="text-sm text-gray-500 mt-1">Enter your new password below.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">New Password</label>
              <input
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#EE5F2B] focus:ring-1 focus:ring-[#EE5F2B] transition"
                type="password"
                name="password"
                placeholder="Enter new password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength={8}
              />
              {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password}</p>}
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Confirm Password</label>
              <input
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#EE5F2B] focus:ring-1 focus:ring-[#EE5F2B] transition"
                type="password"
                name="password_confirmation"
                placeholder="Confirm new password"
                value={formData.password_confirmation}
                onChange={handleChange}
                required
                minLength={8}
              />
              {errors.password_confirmation && <p className="text-red-500 text-xs mt-1">{errors.password_confirmation}</p>}
            </div>

            <button type="submit"
              className="w-full bg-[#EE5F2B] hover:bg-orange-600 text-white font-bold py-3 rounded-xl transition shadow-md hover:shadow-lg text-lg">
              Reset Password
            </button>
          </form>

          <p className="text-center text-sm text-gray-500 mt-4">
            Remember your password?{" "}
            <a href="/login" className="text-[#EE5F2B] font-semibold">Sign in</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPass;
